/**
 * Judge.me → Swiper
 * Извлекает отзывы из виджета Judge.me и строит нативный Swiper-слайдер.
 */
(function () {
  'use strict';

  var swiperInstance = null;

  function safe(str) {
    return String(str || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function extractReview(item) {
    var titleEl  = item.querySelector('.jdgm-carousel-item__review-title');
    var bodyEl   = item.querySelector('.jdgm-carousel-item__review-body');
    var text     = ((titleEl || bodyEl) && (titleEl || bodyEl).textContent || '').trim();
    if (!text) return null;

    var imageEl  = item.querySelector('.jdgm-carousel-item__product-image');
    var ratingEl = item.querySelector('.jdgm-carousel-item__review-rating');

    return {
      name:         (item.querySelector('.jdgm-carousel-item__reviewer-name')?.textContent || '').trim(),
      ratingHTML:   ratingEl ? ratingEl.outerHTML : '',
      text:         text,
      imageSrc:     imageEl ? (imageEl.src || imageEl.dataset.src || '') : '',
      imageAlt:     imageEl ? (imageEl.alt || '') : '',
      productTitle: (item.querySelector('.jdgm-carousel-item__product-title')?.textContent || '').trim(),
      productUrl:   item.querySelector('.jdgm-carousel-item__product')?.href || '#',
    };
  }

  var ARROW_SVG =
    '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 15 15" width="15" height="15">' +
    '<path fill="#30A5ED" d="M3.98348 8.53998L8.98318 13.5397L7.5 15L0 7.5L7.5 0L8.98318 1.46032L3.98348 6.46002H15V8.53998H3.98348Z"/>' +
    '</svg>';

  function buildSlide(r) {
    var productHTML = '';
    if (r.imageSrc) {
      productHTML =
        '<a href="' + safe(r.productUrl) + '" class="rs-product">' +
          '<img src="' + safe(r.imageSrc) + '" alt="' + safe(r.imageAlt) + '" class="rs-product__img" loading="lazy">' +
          '<span class="rs-product__name">' + safe(r.productTitle) + '</span>' +
        '</a>';
    }

    return (
      '<div class="swiper-slide rs-slide">' +
        '<div class="rs-slide__body">' +
          '<div class="rs-slide__meta">' +
            '<span class="rs-slide__author">' + safe(r.name) + '</span>' +
            r.ratingHTML +
          '</div>' +
          '<p class="rs-slide__text">' + safe(r.text) + '</p>' +
        '</div>' +
        productHTML +
      '</div>'
    );
  }

  function build() {
    var jw = document.querySelector('.jdgm-carousel-wrapper');
    if (!jw || jw.dataset.rsDone) return;

    var items = jw.querySelectorAll('.jdgm-carousel-item');
    if (!items.length) return;

    var reviews = Array.from(items).map(extractReview).filter(Boolean);
    if (!reviews.length) return;

    var title =
      (window.reviewsStrings && window.reviewsStrings.customerReviewsTitle) ||
      (jw.querySelector('.jdgm-carousel-title') && jw.querySelector('.jdgm-carousel-title').textContent.trim()) ||
      'Kundenbewertungen';

    // Скрываем оригинальный виджет Judge.me (оставляем в DOM для загрузки шрифтов/ресурсов)
    ['.jdgm-carousel', '.jdgm-carousel-title-and-link', '.jdgm-all-reviews-rating-wrapper'].forEach(function (sel) {
      var el = jw.querySelector(sel);
      if (el) el.style.display = 'none';
    });

    // Строим разметку
    var root = document.createElement('div');
    root.className = 'rs-root';
    root.innerHTML =
      '<div class="rs-header">' +
        '<span class="rs-title">' + safe(title) + '</span>' +
        '<div class="rs-nav">' +
          '<button class="rs-btn rs-btn--prev" aria-label="Previous">' + ARROW_SVG + '</button>' +
          '<button class="rs-btn rs-btn--next" aria-label="Next">' + ARROW_SVG + '</button>' +
        '</div>' +
      '</div>' +
      '<div class="swiper rs-swiper">' +
        '<div class="swiper-wrapper">' +
          reviews.map(buildSlide).join('') +
        '</div>' +
      '</div>';

    jw.appendChild(root);
    jw.dataset.rsDone = '1';

    if (typeof Swiper === 'undefined') return;

    swiperInstance = new Swiper(root.querySelector('.rs-swiper'), {
      slidesPerView: 1.5,
      spaceBetween: 16,
      grabCursor: true,
      loop: false,
      observer: true,
      autoplay: {
        delay: 5000,
        disableOnInteraction: false,
      },
      observeParents: true,
      navigation: {
        prevEl: root.querySelector('.rs-btn--prev'),
        nextEl: root.querySelector('.rs-btn--next'),
      },
      breakpoints: {
        576: {
          slidesPerView: 2.5,
          spaceBetween: 20,
        },
        990: {
          slidesPerView: 4,
          spaceBetween: 24,
        },
      },
    });
  }

  function wait() {
    var attempts = 0;
    var id = setInterval(function () {
      if (document.querySelector('.jdgm-carousel-wrapper .jdgm-carousel-item')) {
        clearInterval(id);
        build();
      }
      if (++attempts >= 100) clearInterval(id);
    }, 100);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', wait);
  } else {
    wait();
  }

  // Резервный запуск после полной загрузки страницы
  window.addEventListener('load', function () {
    setTimeout(build, 800);
  });
})();
